var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardinalityManyOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16H12M15.5 16V23.5C15.5 24.6 14.6 25.5 13.5 25.5H12M15.5 16.25V8.75C15.5 7.65 14.6 6.75 13.5 6.75H12M21 19H24C25.1 19 26 18.1 26 17V15C26 13.9 25.1 13 24 13H21C19.9 13 19 13.9 19 15V17C19 18.1 19.9 19 21 19ZM7.2 18H10.8C11.46 18 12 17.46 12 16.8V15.2C12 14.54 11.46 14 10.8 14H7.2C6.54 14 6 14.54 6 15.2V16.8C6 17.46 6.54 18 7.2 18ZM7.2 27.5H10.8C11.46 27.5 12 26.96 12 26.3V24.7C12 24.04 11.46 23.5 10.8 23.5H7.2C6.54 23.5 6 24.04 6 24.7V26.3C6 26.96 6.54 27.5 7.2 27.5ZM7.2 8.5H10.8C11.46 8.5 12 7.95999 12 7.29999V5.70001C12 5.04001 11.46 4.5 10.8 4.5H7.2C6.54 4.5 6 5.04001 6 5.70001V7.29999C6 7.95999 6.54 8.5 7.2 8.5Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardinalityManyOne);
export default __webpack_public_path__ + "static/media/cardinality-many-one.67222f326113e8025a4d2bcddd7c3ba8.svg";
export { ForwardRef as ReactComponent };